// extracted by mini-css-extract-plugin
module.exports = {"user":"User_user__T_dXn","disabled":"User_disabled__21F-8","primary":"User_primary__2_sZJ","name":"User_name__1nx9K","content":"User_content__s1DV-"};